module.exports = __webpack_public_path__ + "./fonts/Omilia-Logo-notext.svg";